<template>
  <div>
    <!-- <el-link
			class="link__expand"
			:underline="false"
			@click="collapse = !collapse"
			><i
				:class="
					collapse ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'
				"
			></i
		></el-link> -->
    <div class="nav__scroll">
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @select="handleSelect"
        :collapse="collapse"
        background-color="rgb(0, 100, 255)"
        text-color="#fff"
        active-text-color="rgb(0, 229, 140)"
      >
        <template v-if="subMenu">
          <el-submenu
            v-for="item in comData"
            :key="item.index"
            :index="item.index"
          >
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <el-menu-item
              v-for="citem in item.children"
              :key="citem.meta.index"
              :index="citem.meta.index"
              ><router-link class="router-link" :to="citem.path">{{
                citem.meta.title
              }}</router-link></el-menu-item
            >
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item
            v-for="item in data"
            :key="item.index"
            :index="item.index"
            ><i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span></el-menu-item
          >
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import menuData from "@/constant/menu";

export default {
  name: "Aside",
  data() {
    return {
      data: Object.assign({}, menuData),
      collapse: false,
    };
  },
  mounted() {},
  computed: {
    subMenu() {
      let path = this.$route.path;
      return path != "/";
    },
    defaultActive() {
      if (this.subMenu) {
        return this.$route.meta.index;
      }
      return 0 + "";
    },
    comData() {
      console.log(this.data, this.$route);
      if (this.subMenu) {
        let pathname = this.$route.name;
        let match,
          filterList = [];
        for (let i = 0, item; (item = this.data[i]); i++) {
          match = item.children.find((c) => c.name == pathname);
          if (match) {
            filterList.push(item);
            break;
          }
        }
        return filterList;
      } else {
        return this.data;
      }
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      if (!this.subMenu) {
        let data = this.data[key];
        this.scrollIntoView(data.point);
      }
    },
    scrollIntoView(id) {
      let targetElement = document.querySelector("#" + id);
      targetElement &&
        targetElement.scrollIntoView({
          behavior: "smooth",
        });
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: rgb(0, 99, 229) !important;
}

.nav__scroll {
  height: calc(100% - 40px);
  overflow: auto;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0;
  }
  .el-menu {
    border-right: none;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100%;
}
.link__expand {
  display: block;
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  background: #fff;
}
.router-link {
  color: inherit;
  display: block;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue